import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { LocaleString } from '@/api-client/models/utilization/Contracts'
import CardHeatmap from './CardHeatmap.vue'

export type Heatmap = {
  name: string
  title: LocaleString
  info?: LocaleString
  props: any
}

type Props = {
  heatmaps: Heatmap[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HeatmapList',
  props: {
    heatmaps: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heatmaps, (heatmap) => {
    return (_openBlock(), _createBlock(CardHeatmap, {
      key: heatmap.title[_ctx.locale] + heatmap.name
    }))
  }), 128))
}
}

})